import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { FiArrowRight, FiChevronDown, FiDollarSign } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { SearchBarFiltersProps } from "../../constants/constants";
import { Devider, Flex, Form, InputPrice } from "dash-ui";
import { handleGoToFirstPage } from "../../helpers/idx-common-helpers";

export const PriceRangeFilter = ({
  filters,
  mainColor,
  mainColorLight,
  textColor,
  setFilters,
  isMobile = false,
  goToFirstPage,
}: SearchBarFiltersProps) => {
  const { t } = useTranslation(["forms", "pages", "common"]);
  const theme = useTheme();

  async function addMinPriceFilter(value: string) {
    setFilters((draft) => {
      draft.priceRange.min = Number(value);
    });
    handleGoToFirstPage(isMobile, goToFirstPage);
  }
  async function addMaxPriceFilter(value: string) {
    setFilters((draft) => {
      draft.priceRange.max = Number(value);
    });
    handleGoToFirstPage(isMobile, goToFirstPage);
  }

  return isMobile ? (
    <>
      <Flex alignItems="center">
        <Form.Group>
          <Form.Label>{t("forms:labels.priceMin")}</Form.Label>
          <InputPrice
            w="100%"
            placeholder="$500,000"
            value={filters.priceRange.min || ""}
            onChangeValue={(value) => addMinPriceFilter(value)}
          />
        </Form.Group>
        <Devider mt={5} mx={2.5} w={17} color={theme.colors.n80} />
        <Form.Group>
          <Form.Label>{t("forms:labels.priceMax")}</Form.Label>
          <InputPrice
            w="100%"
            placeholder="$1,000,000"
            value={filters.priceRange.max || ""}
            onChangeValue={(value) => addMaxPriceFilter(value)}
          />
        </Form.Group>
      </Flex>
    </>
  ) : (
    <Popover>
      <PopoverButton
        style={{
          backgroundColor: mainColorLight,
          color: mainColor,
        }}
        className="text-sm flex gap-2 items-center rounded-full py-2 px-4 hover:brightness-90 text-white"
      >
        <span>
          Price {(!!filters.priceRange.max || !!filters.priceRange.min) && `*`}
        </span>
        <FiChevronDown />
      </PopoverButton>
      <PopoverPanel
        anchor="bottom end"
        className="bg-white drop-shadow rounded-lg mt-1 flex gap-2 p-4 items-center border"
        style={{ color: textColor }}
      >
        <div className="relative flex items-center">
          <FiDollarSign className="absolute ml-3" />
          <input
            type="number"
            className="pl-8 pr-4 py-2 border border-slate-300 w-40 rounded-lg focus:outline-none"
            placeholder="Min Price"
            value={filters.priceRange.min || ""}
            onChange={(event) => addMinPriceFilter(event.target.value)}
          />
        </div>
        <FiArrowRight className="text-slate-600" />
        <div className="relative flex items-center">
          <FiDollarSign className="text-slate-500 absolute ml-3" />
          <input
            type="number"
            className="pl-8 pr-4 py-2 border border-slate-300 w-40 rounded-lg focus:outline-none"
            placeholder="Max Price"
            value={filters.priceRange.max || ""}
            onChange={(event) => addMaxPriceFilter(event.target.value)}
          />
        </div>
      </PopoverPanel>
    </Popover>
  );
};
